<template>
  <b-container>
    <vue-vimeo-player
        :video-id="videoId"
        :autoplay="autoplay"
        :loop="loop"
        :controls="controls"
        :player-height="playerHeight"
        :player-width="playerWidth"
        />
  </b-container>
</template>

<script>
import { vueVimeoPlayer } from 'vue-vimeo-player'
export default {
  name: "Row_VideoFull",
  components: {
    vueVimeoPlayer
  },
  props: {
    videoId: {
      type: String,
      default: null
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    loop: {
      type: Boolean,
      default: true
    },
    controls: {
      type: Boolean,
      default: true
    },
    playerHeight: {
      type: String,
      default: null
    },
    playerWidth: {
      type: String,
      default: null
    }

},
  methods: {},
  data() {
    return {

    };
  },
};
</script>

<style lang="scss" scoped>
</style>
